// src/pages/SmartHome.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function SmartHome() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Smart Home Installation in Sussex | Automation & Security | SeguraTech</title>
        <meta
          name="description"
          content="SeguraTech designs and installs smart home systems across Sussex, integrating lighting, climate, and security into one reliable, easy to use system."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Smart Home Installation | SeguraTech" />
        <meta
          property="og:description"
          content="Smart home integration across Sussex, combining automation, comfort, and security in one seamless system."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.seguratech.co.uk/smarthome"
        />
        <meta property="og:image" content="/STLogo.png" />
      </Helmet>

      {/* Main Section */}
      <section className="max-w-4xl mx-auto px-4 py-24 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-[#C6A564] mb-6">
          Smart Home Integration
        </h1>
        <p className="text-lg text-white/80 mb-16">
          We create intelligent environments that bring together lighting,
          climate, and security into one seamless experience, managed from
          your phone or by voice.
        </p>

        {/* TP-Link Box */}
        <Link
          to="/tplink"
          className="block border border-[#C6A564] rounded-2xl bg-[#1a1a1a] hover:bg-[#222222] transition flex justify-center items-center"
          style={{ height: "136px", width: "100%", overflow: "hidden" }}
        >
          <img
            src="/TPLink/Tplink.png"
            alt="TP-Link smart home systems"
            className="h-64 w-auto object-contain"
          />
        </Link>
      </section>
    </div>
  );
}
